import { notification } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import ConfigUrl, { axiosbaseurl } from "../../config"
import moment from "moment"
import React, { useEffect, useMemo, useState } from "react"
import { MdAdd, MdDelete, MdEdit, MdSend } from "react-icons/md"
import { SiTicktick } from "react-icons/si"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Swal from "sweetalert2"
import axios from "axios"
import Loader from "pages/Loader"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import { IoMdWarning } from "react-icons/io"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import { RiArrowUpDownFill } from "react-icons/ri"

const UserIndex = () => {
  document.title = "Staff | Return First Investments"

  const { checkAccess } = usePermissionData()

  const Navigate = useNavigate()
  const [Loading, setLoading] = useState(false)
  const [Data, setData] = useState([])
  const [Users, setUsers] = useState([])

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`user-management`)
      if (response?.data?.success) {
        setUsers(response?.data?.data)
        setData(response?.data?.data.reverse())
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = Users.filter(
      session =>
        session.userName.toLowerCase().includes(e.target.value.toLowerCase()) ||
        session.email.toLowerCase().includes(e.target.value.toLowerCase()) ||
        session?.contactNumber
          ?.toLowerCase()
          .includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const handleDelete = async id => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this staff",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    })

    if (result.isConfirmed) {
      try {
        const response = await axiosbaseurl.delete(`/user-management/${id}`) // Use correct API endpoint

        if (response?.data?.success) {
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">
                  Staff Deleted Successfully.
                </div>
              </div>
            ),
            placement: "topRight",
          })

          // Refresh user list after delete
          getData()
        }
      } catch (error) {
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: error?.response?.data?.message,
        })
      }
    }
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  const getSortArrow = key => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "▲" : "▼"
    }
    return <RiArrowUpDownFill size={18} />
  }

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return Data

    const sorted = [...Data].sort((a, b) => {
      let aVal, bVal

      switch (sortConfig.key) {
        case "userName":
          aVal = a.userName?.toLowerCase() || ""
          bVal = b.userName?.toLowerCase() || ""
          break
        case "email":
          aVal = a.email?.toLowerCase() || ""
          bVal = b.email?.toLowerCase() || ""
          break
        case "roleName":
          aVal = a.role?.roleName?.toLowerCase() || ""
          bVal = b.role?.roleName?.toLowerCase() || ""
          break
        case "createdAt":
          aVal = new Date(a.createdAt)
          bVal = new Date(b.createdAt)
          break
        default:
          return 0
      }

      if (aVal < bVal) return sortConfig.direction === "ascending" ? -1 : 1
      if (aVal > bVal) return sortConfig.direction === "ascending" ? 1 : -1
      return 0
    })

    return sorted
  }, [Data, sortConfig])

  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(4, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Staff"} />

            <div className="card p-2 py-3">
              <div className="d-flex flex-column flex-xl-row justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="search-box position-relative">
                    <input
                      className="form-control form-control1 ps-6"
                      placeholder="Search Staff"
                      onChange={filterByName}
                    />
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                  <select
                    className="form-select form-select1 ms-3 fs-6 rounded-5"
                    value={items_perpage}
                    onChange={e => setItemsPerPage(e.target.value)}
                    style={{ width: "110px" }}
                  >
                    <option value="5">Show 5</option>
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="30">Show 30</option>
                  </select>
                </div>

                <div>
                  {checkAccess(4, 2) && (
                    <button
                      className="btn Add-Button rounded-5 mt-3 mt-xl-0"
                      onClick={() => Navigate(`${ConfigUrl.appurl}add-user`)}
                    >
                      <MdAdd /> Add Staff
                    </button>
                  )}
                </div>
              </div>

              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("userName")}
                      >
                        Staff Name {getSortArrow("userName")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("email")}
                      >
                        Email {getSortArrow("email")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("roleName")}
                      >
                        Role {getSortArrow("roleName")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("createdAt")}
                      >
                        Created At {getSortArrow("createdAt")}
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data?.map((item, index) => (
                      <tr key={item?.id} className="h-100">
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td className="h-100 text-start d-flex">
                          {item.profilePhoto && (
                            <img
                              src={`${ConfigUrl.imageurl}${item.profilePhoto}`}
                              width={25}
                              height={25}
                              className="me-3 rounded-circle"
                              style={{ objectFit: "cover" }}
                            />
                          )}
                          {item?.userName}
                        </td>
                        <td>{item?.email}</td>
                        <td>{item?.role?.roleName}</td>
                        <td>
                          {moment(item?.createdAt).format(
                            "DD MMMM YYYY | HH:mm A"
                          )}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center">
                            {checkAccess(4, 3) && (
                              <button
                                className="btn Edit-Button me-2 rounded-5"
                                onClick={() =>
                                  Navigate(
                                    `${ConfigUrl.appurl}edit-user/${item?.id}`
                                  )
                                }
                              >
                                <MdEdit /> Edit
                              </button>
                            )}
                            {checkAccess(4, 4) && (
                              <button
                                className="btn delete-Button rounded-5"
                                onClick={() => handleDelete(item?.id)}
                              >
                                <MdDelete /> Delete
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-6">
                  Showing {final_data?.length} out of {Data?.length} users.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default UserIndex
